import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IPolicyRequest } from '@interfaces/policy-request.interface';
import { IPolicyResponse } from '@interfaces/policy-response.interface';
import { InsuranceService } from 'src/app/core/services/insurance.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'aig-modal-cancel-policy',
  imports: [ModalComponent, FormsModule],
  templateUrl: './modal-cancel-policy.component.html',
  styleUrl: './modal-cancel-policy.component.scss',
})
export class ModalCancelPolicyComponent {
  //#region INPUTS AND OUTPUTS
  @Input() policyResponse: IPolicyResponse | undefined; // Recibe la póliza
  @Input() IdPoliza: number | undefined;
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  clickHide(cancelado: boolean): void {
    this.hideModal.emit(cancelado);
  }
  //#endregion

  //#region VARIABLES
  public confirmChecked: boolean = false;

  public cancelSent: boolean = false;
  //#endregion

  constructor(private insuranceService: InsuranceService) {
    console.log(this.policyResponse);
  }

  //#region PUBLIC METHODS
  public sendCancellation(): void {
    if (this.IdPoliza === null) {
      console.error('Error: IdPoliza es null');
      return; // No continuar si es null
    }

    const policyRequest: IPolicyRequest = {
      nombre: this.policyResponse?.nombre ?? '',
      apellidos: this.policyResponse?.apellidos ?? '',
      fecha_Nacimiento: this.policyResponse?.fecha_Nacimiento ?? '',
      nacionalidad: this.policyResponse?.nacionalidad ?? '',
      num_Documento: this.policyResponse?.num_Documento ?? '',
      email: this.policyResponse?.email ?? '',
      prefijo: this.policyResponse?.prefijo ?? '',
      telefono: this.policyResponse?.telefono ?? '',
      direccion: this.policyResponse?.direccion ?? '',
      bloque: this.policyResponse?.bloque ?? '',
      piso: this.policyResponse?.piso ?? '',
      puerta: this.policyResponse?.puerta ?? '',
      poblacion: this.policyResponse?.poblacion ?? '',
      provincia: this.policyResponse?.provincia ?? '',
      codigo_postal: this.policyResponse?.codigo_postal ?? '',
      pais: this.policyResponse?.pais ?? '',
      iban: this.policyResponse?.iban ?? '', // Incluye el país
      ibanModificado: false,
    };

    console.log(this.IdPoliza);
    console.log(policyRequest);
    if (this.IdPoliza) {
      this.insuranceService
        .suspenderPoliza(this.IdPoliza, policyRequest as IPolicyRequest) // Se fuerza a IPolicy si estamos seguros de que no es null
        .subscribe({
          next: () => {
            this.cancelSent = true;
          },
          error: (error) => {
            console.error('Error al modificar los datos:', error);
          },
        });
    }
  }
  //#endregion
}
